import React from "react";
import Toggle from "components/form/toggle/Toggle";

type EmailBuilderSettingsToggleFieldProps = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
};

export function EmailBuilderSettingsToggleField(props: EmailBuilderSettingsToggleFieldProps) {
  const { label, checked, onChange, disabled = false } = props;

  return (
    <div className="email-builder-settings-toggle-field">
      <Toggle
        labelRight={label}
        size="small"
        checked={checked}
        disabled={disabled}
        onChange={event => onChange(event.target.checked)}
      />
    </div>
  );
}
